<div class="inline-flex items-center">
  <button
    type="button"
    class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors"
    [class.bg-green-pale]="isToggled"
    [class.bg-gray-200]="!isToggled"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    [class.cursor-pointer]="!disabled"
    (click)="toggle()"
    [attr.aria-checked]="isToggled"
    role="switch"
  >
    <span
      class="inline-block h-4 w-4 transform rounded-full transition-transform"
      [class.bg-green]="isToggled"
      [class.bg-gray-400]="!isToggled"
      [class.translate-x-6]="isToggled"
      [class.translate-x-1]="!isToggled"
      [attr.aria-hidden]="true"
    ></span>
  </button>
</div>
